__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "treetop-id-management";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@treetop/id-react", "1.3.0-preview04", () => (Promise.all([__webpack_require__.e(8143), __webpack_require__.e(9602), __webpack_require__.e(2076), __webpack_require__.e(3415), __webpack_require__.e(212), __webpack_require__.e(1667), __webpack_require__.e(3961), __webpack_require__.e(2794), __webpack_require__.e(9895)]).then(() => (() => (__webpack_require__(30806))))));
			register("dayjs", "1.11.13", () => (__webpack_require__.e(6287).then(() => (() => (__webpack_require__(56287))))));
			register("react-dom/client", "18.3.1", () => (Promise.all([__webpack_require__.e(8143), __webpack_require__.e(212), __webpack_require__.e(9576)]).then(() => (() => (__webpack_require__(99576))))));
			register("react-query", "3.39.3", () => (Promise.all([__webpack_require__.e(8143), __webpack_require__.e(2957), __webpack_require__.e(212), __webpack_require__.e(3491)]).then(() => (() => (__webpack_require__(52957))))));
			register("react-router-dom", "6.28.0", () => (Promise.all([__webpack_require__.e(8143), __webpack_require__.e(339), __webpack_require__.e(749), __webpack_require__.e(212), __webpack_require__.e(3119)]).then(() => (() => (__webpack_require__(60749))))));
			register("react-router", "6.28.0", () => (Promise.all([__webpack_require__.e(339), __webpack_require__.e(5387), __webpack_require__.e(212)]).then(() => (() => (__webpack_require__(85387))))));
			register("react", "18.3.1", () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};